import { render, staticRenderFns } from "./TokenManagementBuybackVolume.vue?vue&type=template&id=76337277&scoped=true&lang=pug"
import script from "./TokenManagementBuybackVolume.vue?vue&type=script&lang=ts"
export * from "./TokenManagementBuybackVolume.vue?vue&type=script&lang=ts"
import style0 from "./TokenManagementBuybackVolume.vue?vue&type=style&index=0&id=76337277&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76337277",
  null
  
)

export default component.exports